module.exports = __webpack_public_path__ + "img/contur-focus-yellow.0dbd770a.svg";